module.exports = {
  all: {
    BO_TOK: 'BO_TOK'
  }
};
